// BXYZ:..:eliot@bosmanxyz.xyz:..:.www.bosmanxyz.xyz

(() => {
  const NYCKEL       = 'sm-senaste-samling';
  const AGARE_NYCKEL = 'sm-senaste-agare';
  const sidtyp       = document.documentElement.dataset.sidtyp;

  const sparaSamling = (url, agare) => {
    try {
      if (url && url !== '/') sessionStorage.setItem(NYCKEL, url);
      if (agare)              sessionStorage.setItem(AGARE_NYCKEL, agare);
    } catch (_) {}
  };

  const hamtaSamling = () => {
    try {
      return {
        url:   sessionStorage.getItem(NYCKEL),
        agare: sessionStorage.getItem(AGARE_NYCKEL),
      };
    } catch (_) {
      return { url: null, agare: null };
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    const mittenLank = document.querySelector('.toppstapel__cell--mitten');

    if (sidtyp === 'collection' || sidtyp === 'product') {
      const agareText = mittenLank?.querySelector('.toppstapel__text')?.textContent.trim();
      const href      = mittenLank?.getAttribute('href');
      sparaSamling(href, agareText);
    } else {
      const { url, agare } = hamtaSamling();
      if (mittenLank) {
        if (url)   mittenLank.setAttribute('href', url);
        if (agare) {
          const textSpan = mittenLank.querySelector('.toppstapel__text');
          if (textSpan) textSpan.textContent = agare;
        }
        if (!url) {
          mittenLank.querySelector('svg')?.remove();
        }
      }
    }
  });
})();
